import Image from "next/image";

export const getIconForType = (iconType: string) => {
  switch (iconType) {
    case "bus":
      return (
        <Image
          height={17}
          width={25}
          src="/images/airport_shuttle.svg"
          className="me-8 h-100"
          alt="airport_shuttle"
        />
      );
    case "direction":
      return (
        <Image
          alt="Signs-direction"
          height={17}
          width={25}
          src="/images/signs-direction.svg"
          className="me-8 h-100"
        />
      );
    case "wheelchair":
      return (
        <Image
          src="/search/wheelchair.svg"
          height={25}
          width={25}
          alt="wheelchair"
        />
      );
    default:
      return (
        <Image
          alt="Train icon"
          height={17}
          width={25}
          src="/images/train.svg"
          className="me-8 h-100"
        />
      );
  }
};
